<template>
  <AnalyticsWidget
    title="Slow Collectors List"
    subTitle="List of slow collectors and orders currently pending"
    :gridWidth="gridWidth"
    :gridHeight="gridHeight">
    <div class="p-2 h-100">
      <ReportFilterPopover
        headerTitle="Slow Collector Filter"
        :showApplyButton="true"
        :showResetButton="true"
        :appendToBody="true"
        alignment="left"
        placement="bottom-end"
        @apply="applyContactListFilter"
        @reset="resetContactListFilter">
        <template v-slot:popover>
          <ReportFilterGroup label="Date Filter">
            <ReportDateRangeSelect
              :startDate="editingContactListFilter.startDate"
              :endDate="editingContactListFilter.endDate"
              @updateStartDate="editingContactListFilter.startDate = $event"
              @updateEndDate="editingContactListFilter.endDate = $event"
            />
          </ReportFilterGroup>
        </template>
        <template v-slot:filterDisplay>
          <div>
            <i class="far fa-calendar mr-2"></i>{{appliedContactListFilter.startDate | formatDate}} - {{appliedContactListFilter.endDate | formatDate}}
          </div>
        </template>
      </ReportFilterPopover>

      <LoadingPanel :loading="loading" />
      <Scroller maxHeight="300" height="300">
        <AnalyticsBreakdownTable v-if="!loading">
          <template v-slot:header>
            <tr>
              <th>Contact</th>
              <th>Avg. Delay</th>
              <th>Orders Late</th>
              <th>Current Pending</th>
            </tr>
          </template>
          <template v-slot:body>
            <tr v-for="contactInfo of delayedCollectionSummary" :key="contactInfo.contactId">
              <td><LinkContact :id="contactInfo.contactId" :name="contactInfo.contactName" /></td>
              <td>{{ contactInfo.avgDespatchDurationDays }}d</td>
              <td>{{ contactInfo.orderCount }}</td>
              <td>{{ contactInfo.pendingCount }}</td>
            </tr>
          </template>
        </AnalyticsBreakdownTable>       
      </Scroller>
    </div>
  </AnalyticsWidget>
</template>


<script>
import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsBreakdownTable from '@/modules/intelligence/components/analyticsBreakdownTable'
import AnalyticsBreakdownValueCell from '@/modules/intelligence/components/analyticsBreakdownValueCell'

import ReportFilterPopover from '@/components/reporting/reportFilterPopover'
import ReportDateRangeSelect from '@/components/reporting/reportDateRangeSelect'
import ReportFilterGroup from '@/components/reporting/reportFilterGroup'

import { TaskTypeCategoryTypes } from '@/store/types'

export default {
  name: 'OrderDIFOTSlowCollectorsWidget',
  components: {
    AnalyticsWidget,
    AnalyticsBreakdownTable,
    AnalyticsBreakdownValueCell,
    ReportFilterPopover,
    ReportDateRangeSelect,
    ReportFilterGroup
  },
  props: {
    contactId: Number,
    gridWidth: Number,
    gridHeight: Number
  },
  data() {
    return {
      loading: false,
      delayedCollectionSummary: {},

      defaultContactListFilter: {
        startDate: moment().local().subtract(30, 'days').toDate().toISOString(),
        endDate: moment().local().endOf('month').toDate().toISOString(),
      },
      editingContactListFilter: {},
      appliedContactListFilter: {},
    }
  },
  computed: {
    
  },
  watch: {
    contactId: function() {
      this.requestData()
    }
  },
  mounted() {
    this.editingContactListFilter = _.clone(this.defaultContactListFilter)
    this.appliedContactListFilter = _.clone(this.defaultContactListFilter)

    this.requestData()

    this.subscribeEndpoint('/orders', () => {
      this.requestData()
    })
  },
  beforeDestroy() {
    this.unsubscribeEndpoint('/orders')
  },
  methods: {
    requestData() {
      this.loading = true

      var params = {
        contactId: this.contactId,
        minDurationDays: 2,
        startDate: this.appliedContactListFilter.startDate,
        endDate: this.appliedContactListFilter.endDate,
      }

      Promise.all([
        this.$apiService.analyticsService.getContactDIFOTCollectionDelayList(params),
        this.$apiService.analyticsService.getOrderDIFOTPendingDespatchList()
      ])
      .then(([delayResponse, pendingResponse]) => {
        this.delayedCollectionSummary = delayResponse.data

        // Fill in pending count for each contact
        this.delayedCollectionSummary.forEach(contactInfo => {
          var pendingList = pendingResponse.data.filter(order => order.contact.id == contactInfo.contactId && order.despatchTaskType.reportingCategoryType == TaskTypeCategoryTypes.collection)
          contactInfo.pendingCount = pendingList.length
        })
      })
      .catch(err => {
        console.error(err)
      })
      .finally(() => {
        this.loading = false
      })
    },
    reloadData() {
      this.requestData()
    },
    applyContactListFilter() {
      this.appliedContactListFilter = _.clone(this.editingContactListFilter)

      this.reloadData()
    },
    resetContactListFilter() {
      this.editingContactListFilter = _.clone(this.defaultContactListFilter)
      this.appliedContactListFilter = _.clone(this.defaultContactListFilter)

      this.reloadData()
    },
  }
}
</script>
